module.exports = __webpack_public_path__ + "static/media/tachometer-slowest.0f820e66.svg";